import * as React from "react";
import sideImage from "../../../assets/sample-image.png"
import classes from './ResetPassword.module.scss'
import { Form, Formik } from "formik";
import { Input } from "../../../components/Inputs/Input";
import { ResetFormInitialValues, ResetFormValidation } from "../../../validations/AuthValidations";

export const ResetPassword = () => {

    const handleLogin = (values, resetForm) => {
        console.log({ values });
    }
    return (
        <>
            <div className={classes.parentContainer}>
                <img
                    src={sideImage}
                    alt="decorator"
                    className={classes.sideImage}
                />

                <div className={classes.div}>
                    <div className={classes.div2}>Reset Your Password</div>
                    <div className={classes.div4}>Enter your email and we'll send you a link to reset your password, Please check it.</div>
                    <Formik
                        enableReinitialize
                        initialValues={ResetFormInitialValues}
                        validationSchema={ResetFormValidation}
                        onSubmit={(val, { resetForm }) => handleLogin(val, resetForm)}
                    >
                        {({ errors, touched, values, isValidating, handleSubmit, ...props }) => {
                            return (
                                <Form>
                                    <div>
                                        <div className={classes.div3}>
                                            <Input name='email' type='email' placeholder='' label='Email address' required />
                                        </div>
                                        <div className={classes.div10}>Send</div>
                                    </div>
                                </Form>
                            )
                        }}
                    </Formik>
                    <div className={classes.div12}>Back to Login</div>
                </div>
            </div>
        </>
    );
}
